import React, { useEffect, useMemo, useState } from "react";
import { setTodos } from "../redux/slices/productSlice";
import { useDispatch } from "react-redux";
import { useAddPaymenttMutation } from "../redux/slices/paymentApiSlice";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const Payment = () => {
  const [step, setStep] = useState(1);

  const [data, setData] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);
  const [productsError, setProductsError] = useState("");

  const [manyData, setManyData] = useState([]);
  const [manyLoading, setManyLoading] = useState(false);
  const [manyError, setManyError] = useState("");

  const [kargoData, setKargoData] = useState([]);
  const [kargoLoading, setKargoLoading] = useState(false);
  const [kargoError, setKargoError] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const confirmedCartId = new URLSearchParams(
    location.search
  ).get("confirmedCartId");

  const [addPaymentt] = useAddPaymenttMutation();

  const [name, setName] = useState("");
  const [kuriyer, setKuriyer] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [adress, setAdress] = useState("");
  const [poct, setPoct] = useState("");
  const [city, setCity] = useState("");
  const [photo, setPhoto] = useState(null);
  const [poctType, setPoctType] = useState("");
  const [poctAddress, setPoctAddress] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  /*
   * ---------------------------------------------------------
   * XƏTA MESAJINI İSTİFADƏÇİ ÜÇÜN AÇIQLAYAN FUNKSİYA
   * ---------------------------------------------------------
   */
  const getErrorMessage = (error, defaultMessage) => {
    if (!error) {
      return defaultMessage;
    }

    if (typeof error === "string") {
      return error;
    }

    const responseData = error?.response?.data;
    const apiData = error?.data;

    const message =
      responseData?.message ||
      responseData?.error ||
      responseData?.details ||
      apiData?.message ||
      apiData?.error ||
      apiData?.details ||
      error?.message;

    if (message) {
      return String(message);
    }

    const status =
      error?.response?.status ||
      error?.status;

    if (status === 400) {
      return "Göndərilən məlumatlar düzgün deyil. Zəhmət olmasa məlumatları yenidən yoxlayın.";
    }

    if (status === 401) {
      return "Sessiyanızın müddəti bitmiş ola bilər. Zəhmət olmasa yenidən giriş edin.";
    }

    if (status === 403) {
      return "Bu əməliyyatı yerinə yetirmək üçün icazəniz yoxdur.";
    }

    if (status === 404) {
      return "Sorğu edilən məlumat tapılmadı.";
    }

    if (status === 409) {
      return "Bu məlumat artıq mövcuddur və əməliyyat təkrarlana bilməz.";
    }

    if (status === 422) {
      return "Daxil etdiyiniz məlumatlardan biri düzgün deyil.";
    }

    if (status === 500) {
      return "Serverdə daxili xəta baş verdi. Zəhmət olmasa bir qədər sonra yenidən cəhd edin.";
    }

    if (
      error?.code === "ERR_NETWORK" ||
      error?.message?.toLowerCase?.().includes("network")
    ) {
      return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı yoxlayın.";
    }

    return defaultMessage;
  };

  /*
   * ---------------------------------------------------------
   * MANY API
   * ---------------------------------------------------------
   */
  useEffect(() => {
    const fetchManyData = async () => {
      setManyLoading(true);
      setManyError("");

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/many`
        );

        if (!response.ok) {
          let errorMessage = "";

          try {
            const errorData = await response.json();

            errorMessage =
              errorData?.message ||
              errorData?.error ||
              "";
          } catch {
            // Cavab JSON deyilsə aşağıdakı ümumi xəta göstəriləcək.
          }

          throw new Error(
            errorMessage ||
              `Çatdırılma məlumatları yüklənmədi. Server ${response.status} kodu qaytardı.`
          );
        }

        const result = await response.json();

        if (!Array.isArray(result)) {
          throw new Error(
            "Serverdən çatdırılma məlumatları düzgün formatda gəlmədi."
          );
        }

        setManyData(result);
      } catch (error) {
        console.error("Many API xətası:", error);

        setManyError(
          getErrorMessage(
            error,
            "Çatdırılma məlumatlarını yükləmək mümkün olmadı."
          )
        );
      } finally {
        setManyLoading(false);
      }
    };

    fetchManyData();
  }, []);

  /*
   * ---------------------------------------------------------
   * SƏBƏT MƏHSULLARINI YÜKLƏ
   * ---------------------------------------------------------
   */
  useEffect(() => {
    const fetchProducts = async () => {
      if (!confirmedCartId) {
        setProductsError(
          "Sifariş səbətinin identifikatoru tapılmadı. Sifarişi səbətdən yenidən başladın."
        );
        return;
      }

      setProductsLoading(true);
      setProductsError("");

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/product/payment/${confirmedCartId}`
        );

        const products = response?.data?.products;

        if (!Array.isArray(products)) {
          throw new Error(
            "Serverdən məhsul məlumatları düzgün formatda gəlmədi."
          );
        }

        setData(products);
      } catch (error) {
        console.error("Məhsullar yüklənərkən xəta:", error);

        setProductsError(
          getErrorMessage(
            error,
            "Səbətdəki məhsulları yükləmək mümkün olmadı."
          )
        );
      } finally {
        setProductsLoading(false);
      }
    };

    fetchProducts();
  }, [confirmedCartId]);

  /*
   * ---------------------------------------------------------
   * KARGO MƏLUMATLARINI YÜKLƏ
   * ---------------------------------------------------------
   */
  useEffect(() => {
    const fetchKargoData = async () => {
      setKargoLoading(true);
      setKargoError("");

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/kargo`
        );

        if (!response.ok) {
          let errorMessage = "";

          try {
            const errorData = await response.json();

            errorMessage =
              errorData?.message ||
              errorData?.error ||
              "";
          } catch {
            // JSON cavabı yoxdursa ümumi xəta göstəriləcək.
          }

          throw new Error(
            errorMessage ||
              `Kargo ünvanlarını yükləmək mümkün olmadı. Server ${response.status} kodu qaytardı.`
          );
        }

        const result = await response.json();

        if (!Array.isArray(result)) {
          throw new Error(
            "Kargo ünvanları serverdən düzgün formatda gəlmədi."
          );
        }

        setKargoData(result);
      } catch (error) {
        console.error("Kargo məlumatları yüklənərkən xəta:", error);

        setKargoError(
          getErrorMessage(
            error,
            "Kargo ünvanlarını yükləmək mümkün olmadı."
          )
        );
      } finally {
        setKargoLoading(false);
      }
    };

    if (poctType === "Kargo") {
      fetchKargoData();
    } else {
      setKargoData([]);
      setKargoError("");
      setSearchTerm("");
    }
  }, [poctType]);

  /*
   * ---------------------------------------------------------
   * REDUX-A MƏHSULLARI YAZ
   * ---------------------------------------------------------
   */
  useEffect(() => {
    if (Array.isArray(data)) {
      dispatch(setTodos(data));
    }
  }, [data, dispatch]);

  /*
   * ---------------------------------------------------------
   * ÇATDIRILMA QİYMƏTİ
   * ---------------------------------------------------------
   */
  const getDeliveryPrice = (deliveryData, deliveryType) => {
    if (!deliveryType) {
      return 0;
    }

    const selectedDelivery = deliveryData.find((item) =>
      item.titla
        ?.toLowerCase()
        .includes(deliveryType.toLowerCase())
    );

    if (!selectedDelivery?.titla) {
      return 0;
    }

    const match = selectedDelivery.titla.match(/(\d+)\s*AZN/i);

    return match ? parseInt(match[1], 10) : 0;
  };

  /*
   * ---------------------------------------------------------
   * ÇATDIRILMA MƏBLƏĞİ
   * ---------------------------------------------------------
   */
  const deliveryPrice = useMemo(() => {
    return getDeliveryPrice(manyData, poctType);
  }, [manyData, poctType]);

  /*
   * ---------------------------------------------------------
   * MƏHSULLARIN ÜMUMİ MƏBLƏĞİ
   * ---------------------------------------------------------
   */
  const productsTotal = useMemo(() => {
    if (!Array.isArray(data)) {
      return 0;
    }

    return data.reduce((acc, product) => {
      const price = Number(product?.price) || 0;
      const quantity = Number(product?.quantity) || 0;

      return acc + price * quantity;
    }, 0);
  }, [data]);

  /*
   * ---------------------------------------------------------
   * ÜMUMİ SİFARİŞ MƏBLƏĞİ
   * ---------------------------------------------------------
   */
  const orderTotal = productsTotal + deliveryPrice;

  /*
   * ---------------------------------------------------------
   * SEÇİLMİŞ ÇATDIRILMA MƏLUMATI
   * ---------------------------------------------------------
   */
  const selectedDeliveryInfo = useMemo(() => {
    if (!poctType) {
      return null;
    }

    return manyData.find((item) =>
      item.titla
        ?.toLowerCase()
        .includes(poctType.toLowerCase())
    );
  }, [manyData, poctType]);

  /*
   * ---------------------------------------------------------
   * 1-Cİ ADDIMI YOXLA
   * ---------------------------------------------------------
   */
  const validateStepOne = () => {
    setFormError("");

    if (!name.trim()) {
      setFormError("Adınızı daxil edin.");
      return false;
    }

    if (!surname.trim()) {
      setFormError("Soyadınızı daxil edin.");
      return false;
    }

    if (!email.trim()) {
      setFormError("E-poçt ünvanınızı daxil edin.");
      return false;
    }

    if (!adress.trim()) {
      setFormError("Ünvanınızı daxil edin.");
      return false;
    }

    if (!phone.trim()) {
      setFormError("Telefon nömrənizi daxil edin.");
      return false;
    }

    if (!city.trim()) {
      setFormError("Şəhərinizi daxil edin.");
      return false;
    }

    if (!description.trim()) {
      setFormError("Zəhmət olmasa sifariş haqqında qeyd yazın.");
      return false;
    }

    return true;
  };

  /*
   * ---------------------------------------------------------
   * 2-Cİ ADDIMI YOXLA
   * ---------------------------------------------------------
   */
  const validateStepTwo = () => {
    setFormError("");

    if (!poctType) {
      setFormError("Çatdırılma növünü seçin.");
      return false;
    }

    if (
      (poctType === "Kuryer" ||
        poctType === "Poçt" ||
        poctType === "Kargo") &&
      !poctAddress.trim()
    ) {
      setFormError(
        "Zəhmət olmasa çatdırılma ünvanını seçin və ya daxil edin."
      );
      return false;
    }

    if (poctType === "Kargo" && kargoError) {
      setFormError(
        "Kargo ünvanları yüklənmədiyi üçün davam etmək mümkün deyil. Zəhmət olmasa yenidən cəhd edin."
      );
      return false;
    }

    return true;
  };

  /*
   * ---------------------------------------------------------
   * ÖDƏNİŞİ GÖNDƏR
   * ---------------------------------------------------------
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    setFormError("");

    if (!confirmedCartId) {
      setFormError(
        "Sifariş identifikatoru tapılmadı. Sifarişi səbətdən yenidən başladın."
      );
      return;
    }

    if (!Array.isArray(data) || data.length === 0) {
      setFormError(
        "Səbətdə məhsul yoxdur. Ödənişi tamamlamaq üçün səbətdə ən azı bir məhsul olmalıdır."
      );
      return;
    }

    if (!validateStepOne()) {
      setStep(1);
      return;
    }

    if (!validateStepTwo()) {
      setStep(2);
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();

      formData.append("name", name);
      formData.append("surname", surname);
      formData.append("kuriyer", kuriyer);
      formData.append("city", city);
      formData.append("confirmedCartId", confirmedCartId);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("description", description);
      formData.append("adress", adress);

      const selectedMany = manyData.find((m) =>
        m.titla
          ?.toLowerCase()
          .includes(poctType.toLowerCase())
      );

      const priceText = selectedMany
        ? selectedMany.titla
        : "";

      /*
       * Backend üçün mövcud poct məntiqi saxlanılır.
       */
      if (
        poctType === "Kuryer" ||
        poctType === "Poçt" ||
        poctType === "Kargo"
      ) {
        formData.append(
          "poct",
          `${poctType}: ${poctAddress} , ${priceText}`
        );
      } else {
        formData.append("poct", poctType);
      }

      if (photo) {
        formData.append("photo", photo);
      }

      const newPayment = await addPaymentt(formData).unwrap();

      setTimeout(() => {
        dispatch({
          type: "payment/addPayment",
          payload: newPayment,
        });
      }, 500);

       setTimeout(() => {
            navigate("/confirmed");

      }, 1000);
    } catch (error) {
      console.error(
        "Ödəniş əlavə edilərkən xəta:",
        error
      );

      setFormError(
        getErrorMessage(
          error,
          "Ödənişi tamamlamaq mümkün olmadı. Zəhmət olmasa məlumatları yoxlayıb yenidən cəhd edin."
        )
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  /*
   * ---------------------------------------------------------
   * ADDIM GÖSTƏRİCİSİ
   * ---------------------------------------------------------
   */
  const steps = [
    {
      number: 1,
      title: "Faktura məlumatları",
    },
    {
      number: 2,
      title: "Çatdırılma",
    },
    {
      number: 3,
      title: "Ödəniş",
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 py-6 px-3 sm:px-5 lg:px-8">
      <div className="max-w-7xl mx-auto">

        {/* ------------------------------------------------ */}
        {/* BAŞLIQ */}
        {/* ------------------------------------------------ */}

        <div className="mb-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-600 flex items-center justify-center text-white shadow-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M6 2h12v20H6z" />
                <path d="M9 6h6" />
                <path d="M9 10h6" />
                <path d="M9 14h3" />
              </svg>
            </div>

            <div>
              <h1 className="text-2xl sm:text-3xl font-black text-slate-900 dark:text-white">
                Sifarişi rəsmiləşdirin
              </h1>

              <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                Məlumatları tamamlayaraq sifarişinizi təsdiqləyin.
              </p>
            </div>
          </div>
        </div>

        {/* ------------------------------------------------ */}
        {/* ÜMUMİ XƏTA */}
        {/* ------------------------------------------------ */}

        {formError && (
          <div className="mb-6 rounded-2xl border border-red-200 bg-red-50 dark:border-red-900/50 dark:bg-red-950/30 p-4 shadow-sm">
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 shrink-0 rounded-xl bg-red-100 dark:bg-red-900/50 flex items-center justify-center text-red-600 dark:text-red-400">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v4" />
                  <path d="M12 16h.01" />
                </svg>
              </div>

              <div>
                <p className="font-bold text-red-800 dark:text-red-300">
                  Əməliyyat baş tutmadı
                </p>

                <p className="text-sm text-red-700 dark:text-red-400 mt-1">
                  {formError}
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_390px] gap-6">

          {/* ================================================= */}
          {/* SOL TƏRƏF */}
          {/* ================================================= */}

          <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl shadow-slate-200/50 dark:shadow-black/20 border border-slate-200 dark:border-slate-800 overflow-hidden">

            {/* ADDIMLAR */}

            <div className="p-4 sm:p-6 border-b border-slate-200 dark:border-slate-800">
              <div className="grid grid-cols-3 gap-2 sm:gap-3">
                {steps.map((item) => {
                  const isActive = step === item.number;
                  const isCompleted = step > item.number;

                  return (
                    <div
                      key={item.number}
                      className={`relative rounded-2xl p-3 sm:p-4 border transition-all duration-200 ${
                        isActive
                          ? "border-indigo-500 bg-indigo-50 dark:bg-indigo-950/40 shadow-sm"
                          : isCompleted
                          ? "border-emerald-300 bg-emerald-50 dark:border-emerald-900 dark:bg-emerald-950/20"
                          : "border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-950"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <div
                          className={`w-8 h-8 rounded-xl flex items-center justify-center font-bold text-sm ${
                            isActive
                              ? "bg-indigo-600 text-white"
                              : isCompleted
                              ? "bg-emerald-500 text-white"
                              : "bg-slate-200 dark:bg-slate-800 text-slate-500 dark:text-slate-400"
                          }`}
                        >
                          {isCompleted ? "✓" : item.number}
                        </div>

                        <div className="min-w-0">
                          <p
                            className={`text-xs sm:text-sm font-bold truncate ${
                              isActive
                                ? "text-indigo-700 dark:text-indigo-300"
                                : isCompleted
                                ? "text-emerald-700 dark:text-emerald-300"
                                : "text-slate-500 dark:text-slate-400"
                            }`}
                          >
                            {item.title}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="p-4 sm:p-6 lg:p-8">

              {/* ================================================= */}
              {/* ADDIM 1 */}
              {/* ================================================= */}

              {step === 1 && (
                <div>
                  <div className="mb-7">
                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 text-xs font-bold mb-3">
                      1-ci addım
                    </span>

                    <h2 className="text-2xl font-black text-slate-900 dark:text-white">
                      Faktura məlumatları
                    </h2>

                    <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
                      Sifarişiniz üçün əlaqə və ünvan məlumatlarınızı daxil edin.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">

                    {/* AD */}

                    <div>
                      <label
                        htmlFor="name"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        Ad
                      </label>

                      <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Adınızı daxil edin"
                        className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                      />
                    </div>

                    {/* SOYAD */}

                    <div>
                      <label
                        htmlFor="surname"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        Soyad
                      </label>

                      <input
                        type="text"
                        id="surname"
                        value={surname}
                        onChange={(e) => setSurname(e.target.value)}
                        placeholder="Soyadınızı daxil edin"
                        className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                      />
                    </div>

                    {/* EMAIL */}

                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        E-poçt ünvanı
                      </label>

                      <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="example@mail.com"
                        className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                      />
                    </div>

                    {/* TELEFON */}

                    <div>
                      <label
                        htmlFor="phone"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        Telefon nömrəsi
                      </label>

                      <div className="flex gap-2">
                        <div className="h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-800 flex items-center font-bold text-slate-700 dark:text-slate-300">
                          +994
                        </div>

                        <input
                          type="tel"
                          id="phone"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          placeholder="50 123 45 67"
                          className="flex-1 h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                        />
                      </div>
                    </div>

                    {/* ÜNVAN */}

                    <div className="sm:col-span-2">
                      <label
                        htmlFor="adress"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        Ünvan
                      </label>

                      <input
                        type="text"
                        id="adress"
                        value={adress}
                        onChange={(e) => setAdress(e.target.value)}
                        placeholder="Yaşadığınız ünvanı daxil edin"
                        className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                      />
                    </div>

                    {/* ŞƏHƏR */}

                    <div>
                      <label
                        htmlFor="city"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        Şəhər
                      </label>

                      <input
                        type="text"
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        placeholder="Şəhərinizi daxil edin"
                        className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                      />
                    </div>

                    {/* QEYD */}

                    <div>
                      <label
                        htmlFor="description"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        Qeyd
                      </label>

                      <input
                        type="text"
                        id="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Sifarişinizlə bağlı qeyd"
                        className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end mt-8">
                    <button
                      type="button"
                      onClick={() => {
                        if (validateStepOne()) {
                          setStep(2);
                        }
                      }}
                      disabled={
                        !name ||
                        !surname ||
                        !email ||
                        !adress ||
                        !phone ||
                        !city ||
                        !description
                      }
                      className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 h-12 rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-bold shadow-lg shadow-indigo-500/20 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
                    >
                      Davam et
                      <span>→</span>
                    </button>
                  </div>
                </div>
              )}

              {/* ================================================= */}
              {/* ADDIM 2 */}
              {/* ================================================= */}

              {step === 2 && (
                <div>
                  <div className="mb-7">
                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 text-xs font-bold mb-3">
                      2-ci addım
                    </span>

                    <h2 className="text-2xl font-black text-slate-900 dark:text-white">
                      Çatdırılma məlumatları
                    </h2>

                    <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
                      Sifarişinizin sizə necə çatdırılacağını seçin.
                    </p>
                  </div>

                  <div>
                    <label
                      htmlFor="kuriyer"
                      className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                    >
                      Çatdırılma növü
                    </label>

                    <select
                      id="kuriyer"
                      value={poctType}
                      onChange={(e) => setPoctType(e.target.value)}
                      className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                    >
                      <option value="">
                        Çatdırılma növünü seçin
                      </option>

                      <option value="Kuryer">
                        Kuryer
                      </option>

                      <option value="Kargo">
                        Kargo
                      </option>

                      <option value="Poçt">
                        Poçt
                      </option>

                      <option value="Mağazadan götürmə">
                        Mağazadan götürmə
                      </option>
                    </select>
                  </div>

                  {/* ÇATDIRILMA MƏLUMATI */}

                  {poctType && (
                    <div className="mt-5 rounded-2xl border border-indigo-100 dark:border-indigo-900/50 bg-indigo-50/70 dark:bg-indigo-950/30 p-5">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 shrink-0 rounded-xl bg-indigo-600 text-white flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M3 12h18" />
                            <path d="M12 3v18" />
                          </svg>
                        </div>

                        <div>
                          <p className="font-bold text-indigo-900 dark:text-indigo-200">
                            Seçilmiş çatdırılma növü
                          </p>

                          <p className="text-sm text-indigo-700 dark:text-indigo-300 mt-1">
                            {selectedDeliveryInfo?.titla ||
                              "Bu çatdırılma növü üçün qiymət məlumatı tapılmadı."}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* KARGO */}

                  {poctType === "Kargo" && (
                    <div className="mt-5">
                      <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">
                        Kargo məntəqəsi
                      </label>

                      <div className="relative">
                        <input
                          type="text"
                          placeholder="Kargo məntəqəsini axtarın..."
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setPoctAddress("");
                          }}
                          className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                        />
                      </div>

                      {kargoLoading && (
                        <div className="mt-3 rounded-2xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-5">
                          <div className="flex items-center gap-3">
                            <div className="w-6 h-6 border-2 border-indigo-200 border-t-indigo-600 rounded-full animate-spin" />

                            <div>
                              <p className="font-semibold text-slate-800 dark:text-slate-200">
                                Kargo məntəqələri yüklənir...
                              </p>

                              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                                Məlumatların yüklənməsi bir neçə saniyə çəkə bilər.
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {kargoError && !kargoLoading && (
                        <div className="mt-3 rounded-2xl border border-red-200 bg-red-50 dark:border-red-900/50 dark:bg-red-950/30 p-4">
                          <p className="font-bold text-red-800 dark:text-red-300">
                            Kargo məlumatları yüklənmədi
                          </p>

                          <p className="text-sm text-red-700 dark:text-red-400 mt-1">
                            {kargoError}
                          </p>

                          <button
                            type="button"
                            onClick={() => {
                              setPoctType("");
                              setTimeout(() => {
                                setPoctType("Kargo");
                              }, 0);
                            }}
                            className="mt-3 text-sm font-bold text-red-700 dark:text-red-300 hover:underline"
                          >
                            Yenidən cəhd et
                          </button>
                        </div>
                      )}

                      {!kargoLoading &&
                        !kargoError &&
                        kargoData.length > 0 && (
                          <div className="mt-3 max-h-64 overflow-y-auto rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm">
                            {kargoData
                              .filter((item) =>
                                item.title
                                  ?.toLowerCase()
                                  .includes(
                                    searchTerm.toLowerCase()
                                  )
                              )
                              .map((item, index) => (
                                <button
                                  type="button"
                                  key={
                                    item._id ||
                                    item.id ||
                                    index
                                  }
                                  onClick={() => {
                                    setPoctAddress(item.title);
                                    setSearchTerm(item.title);
                                  }}
                                  className={`w-full text-left px-4 py-3 border-b last:border-b-0 border-slate-100 dark:border-slate-800 hover:bg-indigo-50 dark:hover:bg-indigo-950/30 transition ${
                                    poctAddress === item.title
                                      ? "bg-indigo-50 dark:bg-indigo-950/30"
                                      : ""
                                  }`}
                                >
                                  <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center">
                                      📍
                                    </div>

                                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                                      {item.title}
                                    </span>

                                    {poctAddress ===
                                      item.title && (
                                      <span className="ml-auto text-indigo-600 font-bold">
                                        ✓
                                      </span>
                                    )}
                                  </div>
                                </button>
                              ))}
                          </div>
                        )}

                      {!kargoLoading &&
                        !kargoError &&
                        kargoData.length > 0 &&
                        kargoData.filter((item) =>
                          item.title
                            ?.toLowerCase()
                            .includes(searchTerm.toLowerCase())
                        ).length === 0 && (
                          <div className="mt-3 rounded-2xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-5 text-center">
                            <p className="font-semibold text-slate-700 dark:text-slate-300">
                              Kargo məntəqəsi tapılmadı
                            </p>

                            <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                              Axtarış sözünü dəyişərək yenidən cəhd edin.
                            </p>
                          </div>
                        )}
                    </div>
                  )}

                  {/* KURYER / POÇT */}

                  {(poctType === "Kuryer" ||
                    poctType === "Poçt") && (
                    <div className="mt-5">
                      <label
                        htmlFor="poctAddress"
                        className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2"
                      >
                        Çatdırılma ünvanı
                      </label>

                      <input
                        type="text"
                        id="poctAddress"
                        placeholder="Çatdırılacaq ünvanı daxil edin"
                        value={poctAddress}
                        onChange={(e) =>
                          setPoctAddress(e.target.value)
                        }
                        className="w-full h-12 px-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 transition"
                      />
                    </div>
                  )}

                  {/* MAĞAZADAN GÖTÜRMƏ */}

                  {poctType === "Mağazadan götürmə" && (
                    <div className="mt-5 rounded-2xl border border-emerald-200 bg-emerald-50 dark:border-emerald-900/50 dark:bg-emerald-950/20 p-5">
                      <div className="flex gap-3">
                        <div className="w-10 h-10 shrink-0 rounded-xl bg-emerald-500 text-white flex items-center justify-center">
                          ✓
                        </div>

                        <div>
                          <p className="font-bold text-emerald-800 dark:text-emerald-300">
                            Mağazadan götürmə seçildi
                          </p>

                          <p className="text-sm text-emerald-700 dark:text-emerald-400 mt-1">
                            Sifarişinizi mağazadan özünüz götürə bilərsiniz.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex flex-col-reverse sm:flex-row justify-between gap-3 mt-8">
                    <button
                      type="button"
                      onClick={() => {
                        setFormError("");
                        setStep(1);
                      }}
                      className="w-full sm:w-auto h-12 px-6 rounded-2xl bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-300 dark:hover:bg-slate-700 transition"
                    >
                      ← Geri
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        if (validateStepTwo()) {
                          setStep(3);
                        }
                      }}
                      disabled={
                        !poctType ||
                        ((poctType === "Kuryer" ||
                          poctType === "Poçt" ||
                          poctType === "Kargo") &&
                          !poctAddress)
                      }
                      className="w-full sm:w-auto h-12 px-6 rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-bold shadow-lg shadow-indigo-500/20 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
                    >
                      Davam et →
                    </button>
                  </div>
                </div>
              )}

              {/* ================================================= */}
              {/* ADDIM 3 */}
              {/* ================================================= */}

              {step === 3 && (
                <div>
                  <div className="mb-7">
                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-emerald-50 dark:bg-emerald-950/30 text-emerald-700 dark:text-emerald-300 text-xs font-bold mb-3">
                      3-cü addım
                    </span>

                    <h2 className="text-2xl font-black text-slate-900 dark:text-white">
                      Ödənişi tamamlayın
                    </h2>

                    <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
                      Sifarişinizi təsdiqləmək üçün göstərilən hesaba ödəniş edin.
                    </p>
                  </div>

                  {/* ÖDƏNİŞ MƏLUMATI */}

                  <div className="rounded-3xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 p-5 sm:p-7">

                    <div className="flex items-center gap-3 mb-6">
                      <div className="w-11 h-11 rounded-2xl bg-emerald-500 text-white flex items-center justify-center shadow-lg shadow-emerald-500/20">
                        ✓
                      </div>

                      <div>
                        <h3 className="text-lg font-black text-slate-900 dark:text-white">
                          Sifarişiniz üçün təşəkkür edirik!
                        </h3>

                        <p className="text-sm text-slate-500 dark:text-slate-400">
                          Ödəniş məlumatları aşağıda göstərilib.
                        </p>
                      </div>
                    </div>

                    <div className="rounded-2xl border border-amber-200 bg-amber-50 dark:border-amber-900/50 dark:bg-amber-950/20 p-5 mb-5">
                      <p className="text-sm font-semibold text-amber-800 dark:text-amber-300 leading-6">
                        Sifarişinizin təsdiqlənməsi və sizə göndərilməsi üçün zəhmət olmasa aşağıdakı hesaba ödəniş edin.
                      </p>
                    </div>

                    {/* KART */}

                    <div className="rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-5">
                      <p className="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                        Ödəniş üçün hesab
                      </p>

                      <p className="text-sm font-semibold text-slate-600 dark:text-slate-300 mt-3">
                        Kart / hesab nömrəsi
                      </p>

                      <div className="mt-2 rounded-2xl bg-slate-900 dark:bg-black px-5 py-4">
                        <p className="text-lg sm:text-xl font-black tracking-wider text-white">
                          M10 07771552764
                        </p>
                      </div>
                    </div>

                    <div className="mt-5 flex gap-3">
                      <div className="w-9 h-9 shrink-0 rounded-xl bg-blue-100 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 flex items-center justify-center">
                        ℹ
                      </div>

                      <p className="text-sm text-slate-600 dark:text-slate-400 leading-6">
                        Ödənişi etdikdən sonra qəbzin şəklini bizimlə paylaşın. Qəbz sifarişinizin təsdiqlənməsi üçün tələb oluna bilər.
                      </p>
                    </div>

                    <p className="mt-5 text-center font-bold text-indigo-600 dark:text-indigo-400">
                      Təşəkkür edirik!
                    </p>
                  </div>

                  {/* DÜYMƏLƏR */}

                  <div className="flex flex-col-reverse sm:flex-row justify-between gap-3 mt-8">
                    <button
                      type="button"
                      onClick={() => {
                        setFormError("");
                        setStep(2);
                      }}
                      disabled={isSubmitting}
                      className="w-full sm:w-auto h-12 px-6 rounded-2xl bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-300 dark:hover:bg-slate-700 disabled:opacity-50 transition"
                    >
                      ← Geri
                    </button>

                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                      className="w-full sm:w-auto h-12 px-7 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-black shadow-lg shadow-emerald-500/20 hover:from-emerald-600 hover:to-teal-700 disabled:opacity-60 disabled:cursor-not-allowed transition flex items-center justify-center gap-3"
                    >
                      {isSubmitting ? (
                        <>
                          <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                          Ödəniş göndərilir...
                        </>
                      ) : (
                        <>
                          Ödənişi tamamla
                          <span>✓</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ================================================= */}
          {/* SAĞ TƏRƏF — SİFARİŞ XÜLASƏSİ */}
          {/* ================================================= */}

          <div className="lg:sticky lg:top-5 h-fit space-y-5">

            {/* MƏHSULLAR */}

            <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl shadow-slate-200/50 dark:shadow-black/20 border border-slate-200 dark:border-slate-800 overflow-hidden">

              <div className="p-5 border-b border-slate-200 dark:border-slate-800">
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <h3 className="text-lg font-black text-slate-900 dark:text-white">
                      Səbətinizdəki məhsullar
                    </h3>

                    <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                      Sifarişinizə daxil olan məhsullar
                    </p>
                  </div>

                  {!productsLoading && (
                    <span className="px-3 py-1 rounded-full bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 text-xs font-bold">
                      {data.length} məhsul
                    </span>
                  )}
                </div>
              </div>

              <div className="p-4">

                {/* MƏHSUL YÜKLƏNİR */}

                {productsLoading && (
                  <div className="py-10 text-center">
                    <div className="w-10 h-10 border-4 border-indigo-100 dark:border-slate-700 border-t-indigo-600 rounded-full animate-spin mx-auto" />

                    <p className="font-bold text-slate-700 dark:text-slate-300 mt-4">
                      Məhsullar yüklənir...
                    </p>

                    <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                      Səbət məlumatlarınız hazırlanır.
                    </p>
                  </div>
                )}

                {/* MƏHSUL XƏTASI */}

                {!productsLoading && productsError && (
                  <div className="rounded-2xl border border-red-200 bg-red-50 dark:border-red-900/50 dark:bg-red-950/30 p-4">
                    <div className="flex gap-3">
                      <div className="w-9 h-9 shrink-0 rounded-xl bg-red-100 dark:bg-red-900/50 text-red-600 dark:text-red-400 flex items-center justify-center">
                        !
                      </div>

                      <div>
                        <p className="font-bold text-red-800 dark:text-red-300">
                          Məhsullar yüklənmədi
                        </p>

                        <p className="text-sm text-red-700 dark:text-red-400 mt-1">
                          {productsError}
                        </p>
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={() => {
                        window.location.reload();
                      }}
                      className="mt-4 text-sm font-bold text-red-700 dark:text-red-300 hover:underline"
                    >
                      Səhifəni yenilə
                    </button>
                  </div>
                )}

                {/* BOŞ SƏBƏT */}

                {!productsLoading &&
                  !productsError &&
                  data.length === 0 && (
                    <div className="py-10 text-center">
                      <div className="w-14 h-14 rounded-2xl bg-slate-100 dark:bg-slate-800 mx-auto flex items-center justify-center text-2xl">
                        🛒
                      </div>

                      <p className="font-bold text-slate-800 dark:text-slate-200 mt-4">
                        Səbətinizdə məhsul yoxdur
                      </p>

                      <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                        Ödənişi davam etdirmək üçün səbətinizdə məhsul olmalıdır.
                      </p>
                    </div>
                  )}

                {/* MƏHSULLAR */}

                {!productsLoading &&
                  !productsError &&
                  data.length > 0 && (
                    <div className="max-h-80 overflow-y-auto pr-1 space-y-3">
                      {data.map((product) => {
                        const image = Array.isArray(product?.photo)
                          ? product.photo[0]
                          : product?.photo;

                        const quantity =
                          Number(product?.quantity) || 0;

                        const price =
                          Number(product?.price) || 0;

                        return (
                          <div
                            key={product._id}
                            className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 p-3"
                          >
                            <div className="flex items-center gap-3">
                              <div className="w-14 h-14 shrink-0 rounded-2xl overflow-hidden bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800">
                                {image ? (
                                  <img
                                    src={image}
                                    alt={product?.title || "Məhsul"}
                                    className="w-full h-full object-cover"
                                  />
                                ) : (
                                  <div className="w-full h-full flex items-center justify-center text-slate-400">
                                    🛍️
                                  </div>
                                )}
                              </div>

                              <div className="min-w-0 flex-1">
                                <p className="font-bold text-sm text-slate-800 dark:text-slate-200 truncate">
                                  {product?.title ||
                                    "Adsız məhsul"}
                                </p>

                                <div className="flex items-center justify-between gap-2 mt-1">
                                  <p className="text-xs text-slate-500 dark:text-slate-400">
                                    Miqdar: {quantity}
                                  </p>

                                  <p className="text-sm font-black text-indigo-600 dark:text-indigo-400">
                                    {(price * quantity).toFixed(2)} ₼
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
              </div>
            </div>

            {/* SİFARİŞ XÜLASƏSİ */}

            <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl shadow-slate-200/50 dark:shadow-black/20 border border-slate-200 dark:border-slate-800 overflow-hidden">

              <div className="p-5 border-b border-slate-200 dark:border-slate-800">
                <h3 className="text-lg font-black text-slate-900 dark:text-white">
                  Sifarişin xülasəsi
                </h3>

                <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                  Ödənişdən əvvəl sifariş məlumatlarını yoxlayın.
                </p>
              </div>

              <div className="p-5">

                {/* ÇATDIRILMA */}

                <div className="flex items-start justify-between gap-4 pb-4 border-b border-slate-100 dark:border-slate-800">
                  <div>
                    <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">
                      Çatdırılma növü
                    </p>

                    <p className="text-sm font-bold text-slate-800 dark:text-slate-200 mt-1">
                      {poctType || "Seçilməyib"}
                    </p>
                  </div>

                  {poctType && (
                    <span className="px-2.5 py-1 rounded-lg bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 text-xs font-bold">
                      Seçildi
                    </span>
                  )}
                </div>

                {/* ÇATDIRILMA QİYMƏTİ */}

                <div className="flex items-center justify-between py-4 border-b border-slate-100 dark:border-slate-800">
                  <p className="text-sm text-slate-600 dark:text-slate-400">
                    Çatdırılma haqqı
                  </p>

                  <p className="font-bold text-slate-900 dark:text-white">
                    {deliveryPrice.toFixed(2)} ₼
                  </p>
                </div>

                {/* MƏHSULLARIN MƏBLƏĞİ */}

                <div className="flex items-center justify-between py-4 border-b border-slate-100 dark:border-slate-800">
                  <p className="text-sm text-slate-600 dark:text-slate-400">
                    Məhsulların ümumi məbləği
                  </p>

                  <p className="font-bold text-slate-900 dark:text-white">
                    {productsTotal.toFixed(2)} ₼
                  </p>
                </div>

                {/* ÜMUMİ */}

                <div className="mt-5 rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-600 p-5 text-white shadow-lg shadow-indigo-500/20">
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <p className="text-sm text-white/75">
                        Sifarişin ümumi qiyməti
                      </p>

                      <p className="text-3xl font-black mt-1">
                        {orderTotal.toFixed(2)} ₼
                      </p>
                    </div>

                    <div className="w-11 h-11 rounded-2xl bg-white/15 flex items-center justify-center">
                      ✓
                    </div>
                  </div>
                </div>

                {/* MANY YÜKLƏNMƏ XƏTASI */}

                {manyError && (
                  <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 dark:border-amber-900/50 dark:bg-amber-950/20 p-4">
                    <p className="font-bold text-amber-800 dark:text-amber-300">
                      Çatdırılma qiyməti haqqında xəbərdarlıq
                    </p>

                    <p className="text-xs text-amber-700 dark:text-amber-400 mt-1">
                      {manyError}
                    </p>
                  </div>
                )}

                {/* MANY LOADING */}

                {manyLoading && (
                  <div className="mt-4 flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
                    <span className="w-4 h-4 border-2 border-slate-200 border-t-indigo-600 rounded-full animate-spin" />
                    Çatdırılma qiymətləri yüklənir...
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;

